// extracted by mini-css-extract-plugin
export default {"days_div":"style_days_div__PK+q0","day":"style_day__lGlSa"};